import * as React from 'react';
import { Debounce } from 'react-throttle';
import { map } from 'lodash';
import accounting from 'accounting';

import CartModel from 'src/model/cart.model';
import { IWarrantyProvider } from 'src/model/warranty.model';
import CartItemModel from 'src/model/cartItem.model';
import LocationModel from 'src/model/location.model';

import { goToPartDetail, partDetailUrl } from 'src/utils/navigation';
import { isMobile } from 'src/utils/responsiveHelpers';
import defaultImage from 'src/assets/defaultImage';
import './GridTable.scss';
import Select2 from 'src/components/common/Select2';
import AddToListMenu from 'src/components/AddToListMenu';
import Checkbox from 'src/components/common/Checkbox';
import { ISelectOption } from 'src/components/common/Select2/components/SelectOption/SelectOption';
import env from 'src/shared/env';
import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';
import { WithI18n, withI18n } from 'react-i18next';
import { checkoutCodeSel } from '../../../../store/modules/checkout';
import Alert from 'src/components/common/Alert';
import dropShipIcon from 'src/assets/dropship';

interface IItemsTableProps {
  items: CartModel['items'];
  warrantyProviders?: IWarrantyProvider[];
  deliverMethod: string;
  deliverLocation: LocationModel;
  invalidQtys: { [key: string]: number };
  interQty: number;
  areThereInvalidQtys: boolean;
  onRemoveItem?: (itemID: number) => void;
  onOpenChangeShipFrom?: (item: CartItemModel) => void;
  handleChangeQuantity: (item: CartItemModel, qty: string, quantity: number, amounInStock: number, state: string) => void;
  handleShipmentMarking: (item: CartItemModel, shipmentMarking: string) => void;
  handleTicketNumber: (item: CartItemModel, ticketNumber: string) => void;
  handleChangeWarrantyProvider: (
    item: CartItemModel,
    warrantyProvider: string
  ) => void;
  handleChangeClaims: (item: CartItemModel, claims: string) => void;
  handleRushOrderChange(item: CartItemModel, rushOrder: boolean): void;
  onFoundInactivePart?: (inactiveStatus: boolean, inactivePartId: []) => void;
  t?: any;
  
}

interface IItemsTableState {
  showDropDown: boolean;
  selectedItem: number;
  isMobile: boolean;
  showSpecialMarks: boolean;
  optionUpdatedValues: object;
}

class ItemsTable extends React.Component<IItemsTableProps, IItemsTableState> {
  constructor(props: any) {
    super(props);

    this.state = {
      showDropDown: false,
      selectedItem: 0,
      isMobile: isMobile(),
      showSpecialMarks: false,
      optionUpdatedValues: { values: [] }
    };
  }

  private handleShowDropDown = (item: CartItemModel) => {
    this.setState(prevState => {
      return { showDropDown: !prevState.showDropDown, selectedItem: item.id };
    });
  };

  private handleShowSpecialMarks = () => {
    this.setState(prevState => {
      return { showSpecialMarks: !prevState.showSpecialMarks };
    });
  };

  public renderNotFound(text: string) {
    return (
      <div key="loader0" className="cart-view-not-found">
        {text}
      </div>
    );
  }
  

  public componentDidMount() {
    const arrWithInactivePart: any = [];
    const arrWithInactivePartId: any = [];
    Object.keys(this.props.items).length === 0
          ? this.renderNotFound("Empty Cart")
          : map(this.props.items, (item, j) => {
            if(item.state===null){
              arrWithInactivePart.push(1);
              arrWithInactivePartId.push(item.id)
            }
          })
     if(arrWithInactivePart.length>0){
      this.props.onFoundInactivePart(true,arrWithInactivePartId);
     }else{
      this.props.onFoundInactivePart(false,arrWithInactivePartId);
     }     
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public bottomAlertMessage = (
    backorder: boolean,
    rushOrder: boolean,
    difference: number
  ) => {
    const { t } = this.props;
    const backorderMessage = backorder
      ? env.REACT_APP_BASE_ENVIRONMENT === 'CA'
        ? rushOrder
          ? `${t('common.orderConatinBckRush')}`
          : `${t('common.orderContainsNoRush')}`
        : `${difference} item(s) will be backordered. We will ship them as soon as the stocks are available for shipment.`
      : '';
    return backorderMessage;
  };

  public bottomAlertMessageNoBackorder = (
    backorder: boolean,
    rushOrder: boolean,
    difference: number
  ) => {
    const { t } = this.props;
    const nobackorderMessage = `We are no longer accepting backorders for this product. Please select valid quantity from in stock location(s).`
    return nobackorderMessage;
  };

  private handleOnChangeWarrantyProvider = (sItem: any, sValue: any) => {
    // console.log('sItem>>>>>',sItem);
    // console.log('sValue>>>>>',sValue);
    sValue.value
      ? this.setUpdatedValuesObj(
          sItem.id,
          sValue.value.warrantyClaimNumber,
          sValue.value
        )
      : this.setUpdatedValuesObj(sItem.id, 'None', null);
    this.props.handleChangeWarrantyProvider(
      sItem,
      sValue.value ? sValue.value.providerNumberString : ''
    );
  };
  private setUpdatedValuesObj = (sId: number, name: string, value: any) => {
    const updatedValues: [any] = this.state.optionUpdatedValues['values'];
    const selected = updatedValues.filter(a => a['id'] === sId);
    if (selected.length > 0) {
      selected[0]['name'] = name;
      selected[0]['value'] = value;
    } else {
      const newUpdate = {};
      newUpdate['id'] = sId;
      newUpdate['name'] = name;
      newUpdate['value'] = value;
      updatedValues.push(newUpdate);
    }
    // console.log('setUpdatedValuesObj>>updatedValues>>',updatedValues)
    this.setState({ optionUpdatedValues: { values: updatedValues } });
  };
  private getUpdatedValuesFromObj = (id: number, selectedVal: any) => {
    const updatedValues: [any] = this.state.optionUpdatedValues['values'];
    const selected = updatedValues.filter(a => a['id'] === id);
    if (selected.length > 0) {
      // console.log('setUpdatedValuesObj>>updateselected[0][nam]dValues>>',selected[0]['name'])
      // console.log('setUpdatedValuesObj>>updateselected[0][value]dValues>>',selected[0]['value'])
      return selected[0]['value']
        ? { name: selected[0]['name'], value: selected[0]['value'] }
        : null;
    } else {
      // console.log('setUpdatedValuesObj>>selectedVal param>>',selectedVal);
      return selectedVal ? selectedVal : null;
    }
  };
  private checkItemWarrantyProviders = (item: any) => {
    const updatedValues: [any] = this.state.optionUpdatedValues['values'];
    const selected = updatedValues.filter(a => a['id'] === item.id);
    // console.log('checkItemWarrantyProviders>>>>>selected>>',selected);
    // console.log('checkItemWarrantyProviders>>>>>warrantyProvider>>',item.warrantyProvider);
    if (selected.length > 0) {
      return selected[0]['name'] !== 'None' ? true : false;
    } else {
      return item.warrantyProvider != null && item.warrantyProvider.length > 0
        ? true
        : false;
    }
    // return (selected.length > 0  && selected[0]['name'] !== 'None')? true:false;
  };
  private checkPropsWarrantyProviders = (warrantyProviders: any) => {
    // console.log('warrantyProviders>>>>>>>',warrantyProviders);
    // this.props.warrantyProviders &&
    //                         this.props.warrantyProviders.length > 0
    return warrantyProviders && warrantyProviders.length > 0 ? true : false;
    // return (selected.length > 0  && selected[0]['name'] !== 'None')? true:false;
  };
  private renderWarrantyProviders = (item: CartItemModel) => {
    let options: ISelectOption[] = this.props.warrantyProviders.map(prov => ({
      name: prov.warrantyClaimNumber,
      value: prov
    }));
    options = [{ name: 'None', value: null }, ...options];
    const selectedProvider = this.props.warrantyProviders.find(
      wp => wp.providerNumberString === item.warrantyProvider
    );
    const selected: ISelectOption = selectedProvider
      ? { name: selectedProvider.warrantyClaimNumber, value: selectedProvider }
      : null;

    return (
      <div className="col-12 col-md-4 cart-view--items-table--wpselect">
        <Select2
          label="Add Warranty Provider:"
          options={options}
          selected={this.getUpdatedValuesFromObj(item.id, selected)}
          placeholder="None"
          onSelect={sel => this.handleOnChangeWarrantyProvider(item, sel)}
        />
      </div>
    );
  };

  private handleChangeShipmentMarking = (e: any, item: any) => {
    const shipmentMarking = e.target.value;

    if (
      !shipmentMarking ||
      (shipmentMarking !== ' ' &&
        !startEndWithWhiteSpacesValidation(shipmentMarking))
    ) {
      this.props.handleShipmentMarking(item, shipmentMarking);
    }
  };

  private handleChangeTicketNumber = (e: any, item: any) => {
    const ticketNumber = e.target.value;

    if (
      !ticketNumber ||
      (ticketNumber !== ' ' && !startEndWithWhiteSpacesValidation(ticketNumber))
    ) {
      this.props.handleTicketNumber(item, ticketNumber);
    }
  };

  private handleChangeDispatchClaims = (e: any, item: any) => {
    const claims = e.target.value;

    if (
      !claims ||
      (claims !== ' ' && !startEndWithWhiteSpacesValidation(claims))
    ) {
      this.props.handleChangeClaims(item, claims);
    }
  };

  public renderDesktop() {
    const { t } = this.props;
    return (
      // created by Om
      <table>
        <tr className="rp-cart-view--items-table--headers">
          <th className="rp-PartNumberHeader">
            <p>{t('myReturns.partNumber')}</p>
          </th>
          <th className="rp-InfoHeader">
            <p>{t('cartPage.generalInfo')}</p>
          </th>
          <th className="rp-AvailabilityHeader">
            <p>{t('product.availability')}</p>
          </th>
          <th className="rp-UnitPriceHeader">
            <p>{t('cartPage.unitPrice')}</p>
          </th>
          <th className="rp-ItemTotalHeader">
            <p>{t('myFavourites.itemTotal')}</p>
          </th>
        </tr>
        {Object.keys(this.props.items).length === 0
          ? this.renderNotFound(`${t('common.cartEmptyTxt')}`)
          : map(this.props.items, (item, j) => {
              const disableShipmentMarking = false;
              // item.warrantyProvider != null &&
              // item.warrantyProvider.length > 0;
              const disableQty =
                this.props.areThereInvalidQtys &&
                !this.props.invalidQtys.hasOwnProperty(item.id);
              return (
                <tr className="rp-cart-view--items-table items-table" key={j}>
                  <td colSpan={5}>
                 
                  <table>      
                  <tr className="rp-item-top">
                    <td className="rp-MainInfoArea">
                      <span className="rp-ProductImage">
                        <span className="items-table--item--image">
                          <span
                            className="image-container"
                            style={{
                              backgroundImage: `url(${
                                item.image && item.image !== ''
                                  ? item.image
                                  : defaultImage
                              })`,
                              backgroundSize:
                                item.image && item.image !== ''
                                  ? 'contain'
                                  : 'cover'
                            }}
                          />
                        </span>
                        {env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
                          item.quantity > item.amountInStock && (
                            <span className="items-table--item--rush-flag">
                              <Checkbox
                                name={t('checkoutPage.rushThisItem')}
                                value={''}
                                checked={item.rushOrder}
                                onChange={e =>
                                  this.props.handleRushOrderChange(
                                    item,
                                    e.target.checked
                                  )
                                }
                              />
                            </span>
                          )}
                      </span>
                      <span className="items-table--item--details">
                        <a
                          href={partDetailUrl(item.productNumber)}
                          style={{ cursor: 'pointer' }}
                          onClick={e => goToPartDetail(item.productNumber)}
                          className="item-name"
                        >
                          {item.manufacturerCode} {item.name}
                        </a>
                        <p className="item-details">{item.description}</p>
                      </span>
                    </td>
                    <td className="rp-SecondaryArea">
                      <table>
                      <tr>
                        <td>
                      <table className="rp-SecondaryArea-top">
                        <tr className="rp-GeneralArea">
                          <td className="rp-Quantity">
                            <span className="items-table--item--qty">
                              <label htmlFor="quantity">
                                {t('myFavourites.qty')}:
                              </label>
                              <Debounce time="500" handler="onChange">
                                <input
                                  type="text"
                                  step={1}
                                  min={1}
                                  id="quantity"
                                  name="item-quantity"
                                  defaultValue={`${item.quantity}`}
                                  className={`quantity-input ${
                                    disableQty ? 'disabled' : ''
                                  }`}                                  
                                  disabled={item.state === 'In Stock No Backorder' && !item.amountInStock ? true : disableQty}
                                  onChange={e =>
                                    this.props.handleChangeQuantity(
                                      item,
                                      e.target.value,
                                      item.quantity,
                                      item.amountInStock,
                                      item.state
                                    )
                                  }
                                />
                              </Debounce>
                            </span>
                          </td>
                          <td className="lt-ShipFrom">
                            <span className="items-table--item--shipsfrom">
                              <p className="shipfrom-title">
                                {this.props.deliverMethod === 'Shipping'
                                  ? `${t('cartPage.shipFrom')}:`
                                  : `${t('product.suppliedFrom')}:`}
                              </p>
                              <p className="shipfrom-name">
                                {item.shipsfrom && item.shipsfrom.name.search(' PICK UP ONLY') >
                                  0 && env.REACT_APP_BASE_ENVIRONMENT === 'US'
                                  ? item.shipsfrom.name.slice(
                                      0,
                                      item.shipsfrom.name.search(
                                        ' PICK UP ONLY'
                                      ) + 1
                                    )
                                  : item.shipsfrom?.name}
                              </p>
                              <a
                                href="javascript:void(0)"
                                className="shipfrom-change"
                                onClick={() =>
                                  this.props.onOpenChangeShipFrom(item)
                                }
                              >
                                {t('common.change')}
                              </a>
                            </span>
                          </td>
                        </tr>
                      </table>

                      </td></tr>
                      <tr><td>            
                      <span className="rp-ItemSpecialMarks">
                        <span className="row col-extra-info items-table--item--special-marks">
                          <span className="col-12 col-md-8 special-mark-item d-flex">
                            <span>
                              <label
                                htmlFor="shipment-marking"
                                className={
                                  disableShipmentMarking ? 'disabled' : ''
                                }
                              >
                                {t('myFavourites.shipmentMarking')}:
                              </label>
                              <Debounce time="500" handler="onChange">
                                <input
                                  type="text"
                                  id="shipment-marking"
                                  className={
                                    disableShipmentMarking ? 'disabled' : ''
                                  }
                                  name="shipment-marking"
                                  defaultValue={item.shipmentMarking}
                                  onChange={e =>
                                    this.handleChangeShipmentMarking(e, item)
                                  }
                                  disabled={disableShipmentMarking}
                                  maxLength={30}
                                />
                              </Debounce>
                            </span>
                          </span>
                          {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                            <span className="col-12 col-md-4 special-mark-item">
                              <label htmlFor="ticket-number">
                                {t('product.ticket')} / {t('product.dispatch#')}
                                :
                              </label>
                              <Debounce time="500" handler="onChange">
                                <input
                                  type="text"
                                  id="ticket-number"
                                  name="ticket-number"
                                  defaultValue={item.ticketNumber}
                                  onChange={e =>
                                    this.handleChangeTicketNumber(e, item)
                                  }
                                  maxLength={10}
                                />
                              </Debounce>
                            </span>
                          ) : (
                            this.props.warrantyProviders &&
                            this.props.warrantyProviders.length > 0 &&
                            this.renderWarrantyProviders(item)
                          )}

                          {this.props.warrantyProviders &&
                            this.props.warrantyProviders.length > 0 &&
                            this.checkItemWarrantyProviders(item) && (
                              <span className="col-12 col-md-4 special-mark-item">
                                <label htmlFor="claims">
                                  {t('myFavourites.dispatch')} /{' '}
                                  {t('product.claims_plural')}:
                                </label>
                                <Debounce time="500" handler="onChange">
                                  <input
                                    type="text"
                                    defaultValue={item.claims}
                                    id="claims"
                                    name="claims"
                                    onChange={e =>
                                      this.handleChangeDispatchClaims(e, item)
                                    }
                                    maxLength={15}
                                  />
                                </Debounce>
                              </span>
                            )}
                        </span>
                      </span>
                      </td></tr>
                      </table>

                    </td>
                    <td className="rp-Availability"  style={{ paddingLeft: '46px' }}>
                      <span>
                        {item.amountInStock ? (
                          <p className="items-table--item--status">
                            <i className="rpds rpds-check-circle" />
                            {t('common.inStock')}
                          </p>
                        ) : (
                          <p className="items-table--item--status">
                            <i className="rpds rpds-remove-circle" />
                            {t('common.outOfStock')}
                          </p>
                        )}
                        {item.specialOrder && (
                          <p className="items-table--item--status">
                            <i
                              className={`rpds rpds-new-releases special-order`}
                            />
                            {t('general.nonReturn')}
                          </p>
                        )}
                        {item.isDropShip && (
                          <p className="items-table--item--status">
                            <span><img src={dropShipIcon} alt="Dropship Only" className="dropship-icon-grid" /></span>
                            <span>{t('general.dropShipOnly')}</span>
                          </p>
                        )}
                      </span>
                    </td>
                    <td className="rp-UnitPrice">
                      <span>
                        <span className="items-table--item--unit-price">
                          <span className="item--title">
                            {(t('cartPage.unitPrice') as string).toUpperCase()}
                          </span>
                          {accounting.formatMoney(item.unitPrice)}
                        </span>
                      </span>
                    </td>
                    <td className="rp-ItemTotal">
                      <span>
                        <span className="items-table--item--total-price">
                          <span className="item--title">
                            {(t(
                              'myFavourites.itemTotal'
                            ) as string).toUpperCase()}
                          </span>
                          {accounting.formatMoney(item.itemTotal)}
                        </span>
                      </span>
                    </td>
                  </tr>
                  {item.subItems &&
                    item.subItems.length > 0 &&
                    item.subItems.map((subitem, i) => {
                      return (
                        subitem.totalAmount>0 && (  
                        <tr key={i} className="items-table--item--subitems">
                          <span className="rp-SubItems">
                            <td className="SubItemsFirst" >
                              <span className="rp-SubItemProductImage">
                              <span className="items-table--item--image">
                                <span
                                  className="image-container"
                                  style={{
                                    backgroundImage: `url(${
                                      subitem.imageURL &&
                                      subitem.imageURL !== ''
                                        ? subitem.imageURL
                                        : defaultImage
                                    })`,
                                    backgroundSize:
                                      subitem.imageURL &&
                                      subitem.imageURL !== ''
                                        ? 'contain'
                                        : 'cover'
                                  }}
                                />
                              </span></span>
                              <span className="rp-SubItemProductInfo">
                              <span className="items-table--item--details">
                                <p className="item-name">
                                  {subitem.productNumber}
                                </p>
                                <p className="item-details">
                                  {subitem.description}
                                </p>
                              </span> 
                              </span>
                            </td>
                            <td className="rp-SubItemQuantity">
                              <span className="form-item">
                                <label htmlFor="quantity">
                                  {t('myFavourites.qty')}:{' '}
                                </label>
                                {subitem.quantity}
                              </span>
                            </td>
                            
                            <td className="rp-SubItemProductInfo"/>

                            <td className="rp-SubItemUnitPrice">
                              <span className="items-table--item--unit-price">
                                <span className="item--title">
                                  {(t(
                                    'cartPage.unitPrice'
                                  ) as string).toUpperCase()}
                                </span>
                                {accounting.formatMoney(subitem.partnerPrice)}
                              </span>
                            </td>
                            <td className="rp-SubItemItemTotal">
                              <span className="items-table--item--total-price">
                                <span className="item--title">
                                  {(t(
                                    'myFavourites.itemTotal'
                                  ) as string).toUpperCase()}
                                </span>
                                {accounting.formatMoney(subitem.totalAmount)}
                              </span>
                            </td>
                          </span>
                        </tr>
                        )
                      );
                    })}
                  <tr className="lt-ItemActions no-select">
                    <td colSpan={5}>
                    <span className="items-table--item--actions">
                    {(this.props.interQty > item.amountInStock && item.state === 'In Stock No Backorder'  && (
                        <span className={item.rushOrder ? 'rush' : 'disclaimer'}>
                          <i className="rpds-local-shipping" />
                          {this.bottomAlertMessageNoBackorder(
                            item.quantity > item.amountInStock,
                            item.rushOrder,
                            item.quantity - item.amountInStock
                          )}
                        </span>
                      )) || <span />}

                        {(item.quantity > item.amountInStock && item.state !== 'In Stock No Backorder' && (
                          <span className={item.rushOrder ? 'rush' : 'disclaimer'}>
                            <i className="rpds-local-shipping" />
                            {this.bottomAlertMessage(
                              item.quantity > item.amountInStock,
                              item.rushOrder,
                              item.quantity - item.amountInStock
                            )}
                          </span>
                        )) || <span />}

                      <span className="actions">
                        {item.alternateProductNumber &&
                        !item.oemProductNumber ? (
                          <span>
                            <button
                              className="viewbutton"
                              type="button"
                              onClick={e => {
                                goToPartDetail(
                                  `${item.alternateProductManufacturer}  ${item.alternateProductNumber}`
                                );
                              }}
                            >
                              {t('myFavourites.viewnonoem')}
                            </button>
                          </span>
                        ) : (
                          ''
                        )}
                        {item.oemProductNumber &&
                        !item.alternateProductNumber ? (
                          <span>
                            <button
                              className="viewbutton"
                              type="button"
                              // href={partDetailUrl(
                              //   `${item.oemProductManufacturer}  ${item.oemProductNumber}`
                              // )}
                              onClick={e => {
                                goToPartDetail(
                                  `${item.oemProductManufacturer}  ${item.oemProductNumber}`
                                );
                              }}
                            >
                              {t('myFavourites.viewoem')}
                            </button>
                          </span>
                        ) : (
                          ''
                        )}
                        {item.replacementMfc && item.replacementPart ? (
                          <button
                            className="subavailable"
                            onClick={e => {
                              goToPartDetail(
                                `${item.replacementMfc}  ${item.replacementPart}`
                              );
                            }}
                          >
                            {t('myFavourites.subavailable')}
                          </button>
                        ) : (
                          ''
                        )}

                        <a onClick={() => this.props.onRemoveItem(item.id)}>
                          {(t('common.removeAction') as string).toUpperCase()}
                        </a>
                        <i className="divider" />
                        <AddToListMenu
                          direction="top"
                          label={t('common.addToList')}
                          height="38px"
                          width="110px"
                          part={item}
                        />
                      </span>
                    </span>
                    </td>
                  </tr>
                  </table>
                  </td>
                </tr>
              );
            })}
      </table>
      // Created code end by Om
    );
  }

  public renderMobile() {
    const { t } = this.props;
    return (
      <div>
        {Object.keys(this.props.items).length === 0
          ? this.renderNotFound(`${t('common.cartEmptyTxt')}`)
          : map(this.props.items, (item, j) => {
              const disableShipmentMarking = false;
              // item.warrantyProvider != null &&
              // item.warrantyProvider.length > 0;
              const disableQty =
                this.props.areThereInvalidQtys &&
                !this.props.invalidQtys.hasOwnProperty(item.id);
              return (
                <div className="rp-cart-view--items-table items-table" key={j}>
                  <div className="rp-item-top--mobile">
                    <div className="rp-ProductImage">
                      <div className="items-table--item--image">
                        <div
                          className="image-container"
                          style={{
                            backgroundImage: `url(${
                              item.image && item.image !== ''
                                ? item.image
                                : defaultImage
                            })`,
                            backgroundSize:
                              item.image && item.image !== ''
                                ? 'contain'
                                : 'cover'
                          }}
                        />
                      </div>
                      {env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
                        item.quantity > item.amountInStock && (
                          <div className="lt-RushFlag">
                            <div className="items-table--item--rush-flag">
                              <Checkbox
                                name={t('checkoutPage.rushThisItem')}
                                value={''}
                                checked={item.rushOrder}
                                onChange={e =>
                                  this.props.handleRushOrderChange(
                                    item,
                                    e.target.checked
                                  )
                                }
                              />
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="rp-InfoArea">
                      <div className="rp-ProductInfo">
                        <div className="items-table--item--details">
                          <a
                            href={partDetailUrl(item.productNumber)}
                            style={{ cursor: 'pointer' }}
                            onClick={e => goToPartDetail(item.productNumber)}
                            className="item-name"
                          >
                            {item.manufacturerCode} {item.name}
                          </a>
                          <p className="item-details">{item.description}</p>
                        </div>
                      </div>
                      <div className="rp-Availability">
                        {item.amountInStock ? (
                          <div className="items-table--item--availability">
                            <i className="rpds rpds-check-circle" />
                            {t('common.inStock')}
                          </div>
                        ) : (
                          <div className="items-table--item--availability">
                            <i className="rpds rpds-remove-circle" />
                            {t('common.outOfStock')}
                          </div>
                        )}
                        {item.specialOrder && (
                          <div className="items-table--item--status">
                            <i
                              className={`rpds rpds-new-releases special-order`}
                            />
                            {t('general.nonReturn')}
                          </div>
                        )}
                        {item.isDropShip && (
                          <div className="items-table--item--status">
                            <span><img src={dropShipIcon} alt="Dropship Icon" className="dropship-icon-grid" /></span>
                            <span>{t('general.dropShipOnly')}</span>
                          </div>
                        )}
                      </div>
                      <div className="rp-UnitPrice">
                        <div className="items-table--item--unit-price">
                          <div className="item--title">
                            {(t('cartPage.unitPrice') as string).toUpperCase()}
                          </div>
                          {accounting.formatMoney(item.unitPrice)}
                        </div>
                      </div>
                      <div className="rp-ItemTotal">
                        <div className="items-table--item--total-price">
                          <div className="item--title">
                            {(t(
                              'myFavourites.itemTotal'
                            ) as string).toUpperCase()}
                          </div>
                          {accounting.formatMoney(item.itemTotal)}
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.isMobile && (
                    <div
                      className="items-table--item-mobile--form-hidden-menu lt-ItemSpecialMarksMobileTopBar"
                      onClick={this.handleShowSpecialMarks}
                    >
                      {t('cartPage.orderDetails')}
                      <span
                        className={`${
                          this.state.showSpecialMarks
                            ? 'rpds-remove'
                            : 'rpds-add'
                        } rp-add-icon`}
                      />
                    </div>
                  )}
                  {(!this.state.isMobile || this.state.showSpecialMarks) && (
                    <React.Fragment>
                      <div className="rp-special-marks-top--mobile">
                        <div className="rp-Quantity">
                          <div className="items-table--item--qty">
                            <label htmlFor="quantity">
                              {t('myFavourites.qty')}:
                            </label>
                            <Debounce time="500" handler="onChange">
                              <input
                                type="number"
                                step={1}
                                min={1}
                                id="quantity"
                                name="item-quantity"
                                defaultValue={`${item.quantity}`}
                                className={`quantity-input ${
                                  disableQty ? 'disabled' : ''
                                }`}
                                disabled={disableQty}
                                onChange={e =>
                                  this.props.handleChangeQuantity(
                                    item,
                                    e.target.value,
                                    item.quantity,
                                    item.amountInStock,
                                    item.state
                                  )
                                }
                              />
                            </Debounce>
                          </div>
                        </div>
                        <div className="rp-ShipFrom">
                          <div className="items-table--item--shipsfrom">
                            <p className="shipfrom-title">
                              {t('cartPage.shipFrom')}:
                            </p>
                            <p className="shipfrom-name">
                              {item.shipsfrom.name}
                            </p>
                            <a
                              href="javascript:void(0)"
                              className="shipfrom-change"
                              onClick={() =>
                                this.props.onOpenChangeShipFrom(item)
                              }
                            >
                              {t('common.change')}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="rp-ItemSpecialMarks">
                        <div className="row col-extra-info items-table--item--special-marks">
                          <div className="col-12 col-md-4">
                            <label
                              htmlFor="shipment-marking"
                              className={
                                disableShipmentMarking ? 'disabled' : ''
                              }
                            >
                              {t('myFavourites.shipmentMarking')}:
                            </label>
                            <Debounce time="500" handler="onChange">
                              <input
                                type="text"
                                id="shipment-marking"
                                className={
                                  disableShipmentMarking ? 'disabled' : ''
                                }
                                name="shipment-marking"
                                defaultValue={item.shipmentMarking}
                                onChange={e =>
                                  this.handleChangeShipmentMarking(e, item)
                                }
                                disabled={disableShipmentMarking}
                              />
                            </Debounce>
                          </div>
                          {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                            <div className="col-12 col-md-4">
                              <label htmlFor="ticket-number">
                                {t('product.ticket')} / {t('product.dispatch#')}
                                :
                              </label>
                              <Debounce time="500" handler="onChange">
                                <input
                                  type="text"
                                  id="ticket-number"
                                  name="ticket-number"
                                  defaultValue={item.ticketNumber}
                                  onChange={e =>
                                    this.props.handleTicketNumber(
                                      item,
                                      e.target.value
                                    )
                                  }
                                  maxLength={10}
                                />
                              </Debounce>
                            </div>
                          ) : (
                            this.props.warrantyProviders &&
                            this.props.warrantyProviders.length > 0 &&
                            this.renderWarrantyProviders(item)
                          )}
                          {item.warrantyProvider != null &&
                            item.warrantyProvider.length > 0 &&
                            this.props.warrantyProviders &&
                            this.props.warrantyProviders.length > 0 && (
                              <div className="col-12 col-md-4">
                                <label htmlFor="claims">
                                  {t('myFavourites.dispatch')} /{' '}
                                  {t('product.claims_plural')}:
                                </label>
                                <Debounce time="500" handler="onChange">
                                  <input
                                    type="text"
                                    defaultValue={item.claims}
                                    id="claims"
                                    name="claims"
                                    onChange={e =>
                                      this.handleChangeDispatchClaims(e, item)
                                    }
                                  />
                                </Debounce>
                              </div>
                            )}
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                  {item.subItems &&
                    item.subItems.length > 0 &&
                    item.subItems.map((subitem, i) => {
                      return (
                        subitem.totalAmount>0 && (  
                        <div key={i} className="items-table--item--subitems">
                          <div className="rp-SubItems--mobile">
                            <div className="rp-SubItemProductImage">
                              <div className="items-table--item--image">
                                <div
                                  className="image-container"
                                  style={{
                                    backgroundImage: `url(${
                                      subitem.imageURL &&
                                      subitem.imageURL !== ''
                                        ? subitem.imageURL
                                        : defaultImage
                                    })`,
                                    backgroundSize:
                                      subitem.imageURL &&
                                      subitem.imageURL !== ''
                                        ? 'contain'
                                        : 'cover'
                                  }}
                                />
                              </div>
                            </div>
                            <div className="rp-SubItemInfoArea">
                              <div className="rp-SubItemProductInfo">
                                <div className="items-table--item--details">
                                  <p className="item-name">
                                    {subitem.productNumber}
                                  </p>
                                  <p className="item-details">
                                    {subitem.description}
                                  </p>
                                </div>
                              </div>
                              <div className="rp-SubItemQuantity">
                                <div className="form-item">
                                  <label htmlFor="quantity">
                                    {t('myFavourites.qty')}:
                                  </label>
                                  {subitem.quantity}
                                </div>
                              </div>
                              <div className="rp-SubItemUnitPrice">
                                <div className="items-table--item--unit-price">
                                  <div className="item--title">
                                    {(t(
                                      'cartPage.unitPrice'
                                    ) as string).toUpperCase()}
                                  </div>
                                  {accounting.formatMoney(subitem.partnerPrice)}
                                </div>
                              </div>
                              <div className="rp-SubItemItemTotal">
                                <div className="items-table--item--total-price">
                                  <div className="item--title">
                                    {(t(
                                      'myFavourites.itemTotal'
                                    ) as string).toUpperCase()}
                                    L
                                  </div>
                                  {accounting.formatMoney(subitem.totalAmount)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                      );
                    })}
                  <div className="lt-ItemActions no-select">
                    <div className="items-table--item--actions">
                    {(item.quantity > item.amountInStock && item.state === 'In Stock No Backorder'  && (
                      <div className={item.rushOrder ? 'rush' : 'disclaimer'}>
                            <i className="rpds-local-shipping" />
                            {this.bottomAlertMessageNoBackorder(
                              item.quantity > item.amountInStock,
                              item.rushOrder,
                              item.quantity - item.amountInStock
                            )}
                            </div>)) || <div />}

                        {(item.quantity > item.amountInStock && item.state !== 'In Stock No Backorder' && (
                          <div className={item.rushOrder ? 'rush' : 'disclaimer'}>
                            <i className="rpds-local-shipping" />
                            {this.bottomAlertMessage(
                              item.quantity > item.amountInStock,
                              item.rushOrder,
                              item.quantity - item.amountInStock
                            )}
                          </div>
                        )) || <div />}

                      <div className="actions">
                        {item.alternateProductNumber &&
                        !item.oemProductNumber ? (
                          <div>
                            <button
                              className="viewbutton"
                              type="button"
                              // href={partDetailUrl(
                              //   `${item.alternateProductManufacturer}  ${item.alternateProductNumber}`
                              // )}
                              onClick={e => {
                                goToPartDetail(
                                  `${item.alternateProductManufacturer}  ${item.alternateProductNumber}`
                                );
                              }}
                            >
                              {t('myFavourites.viewnonoem')}
                            </button>
                          </div>
                        ) : (
                          ''
                        )}
                        {item.oemProductNumber &&
                        !item.alternateProductNumber ? (
                          <div>
                            <button
                              className="viewbutton"
                              type="button"
                              // href={partDetailUrl(
                              //   `${item.oemProductManufacturer}  ${item.oemProductNumber}`
                              // )}
                              onClick={e => {
                                goToPartDetail(
                                  `${item.oemProductManufacturer}  ${item.oemProductNumber}`
                                );
                              }}
                            >
                              {t('myFavourites.viewoem')}
                            </button>
                          </div>
                        ) : (
                          ''
                        )}
                        {item.replacementMfc && item.replacementMfc ? (
                          <button
                            className="subavailable"
                            onClick={e => {
                              goToPartDetail(
                                `${item.replacementMfc}  ${item.replacementPart}`
                              );
                            }}
                          >
                            {' '}
                            {t('myFavourites.subavailable')}
                          </button>
                        ) : (
                          ''
                        )}

                        <a onClick={() => this.props.onRemoveItem(item.id)}>
                          {(t('common.removeAction') as string).toUpperCase()}
                        </a>
                        <i className="divider" />
                        <AddToListMenu
                          direction="top"
                          label={t('common.addToList')}
                          height="28px"
                          part={item}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    );
  }

  public render() {
    return (
      <React.Fragment>
        {this.state.isMobile ? this.renderMobile() : this.renderDesktop()}
      </React.Fragment>
    );
  }
}

export default withI18n()(ItemsTable);
